"use strict";
exports.__esModule = true;
var UserModule = /** @class */ (function () {
    function UserModule(gatewayClient) {
        this.gatewayClient = gatewayClient;
    }
    /**
     * 登录
     * @param username
     * @param password
     */
    UserModule.prototype.login = function (username, password) {
        return this.gatewayClient.login(username, password);
    };
    /**
     * 注销
     * @param token
     */
    UserModule.prototype.logout = function (token) {
        return this.gatewayClient.logout(token);
    };
    /**
     * 修改个人密码
     * @param token
     * @param newPassWord
     * @param orgPassWord
     * @param username
     */
    UserModule.prototype.updatePassword = function (token, newPassWord, orgPassWord, username) {
        return this.gatewayClient.updatePassword(token, newPassWord, orgPassWord, username);
    };
    /**
     * 检查用户权限接口
     * @param reqUrl 需要请求的功能代号 stopList-停用单
     * @param token
     */
    UserModule.prototype.queryUserPower = function (action, token) {
        function getActionUrl(code) {
            switch (code) {
                case 'stopList':
                    return '/excel/stopList';
                default:
                    return '';
            }
        }
        return this.gatewayClient.checkUserPower(getActionUrl(action), token);
    };
    return UserModule;
}());
exports.UserModule = UserModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy91c2VyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBR0E7SUFFRSxvQkFBWSxhQUE0QjtRQUN0QyxJQUFJLENBQUMsYUFBYSxHQUFHLGFBQWEsQ0FBQztJQUNyQyxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLDBCQUFLLEdBQVosVUFBYSxRQUFnQixFQUFFLFFBQWdCO1FBQzdDLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLEtBQUssQ0FBQyxRQUFRLEVBQUUsUUFBUSxDQUFDLENBQUM7SUFDdEQsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDJCQUFNLEdBQWIsVUFBYyxLQUFhO1FBQ3pCLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUMxQyxDQUFDO0lBRUQ7Ozs7OztPQU1HO0lBQ0ksbUNBQWMsR0FBckIsVUFDRSxLQUFhLEVBQ2IsV0FBbUIsRUFDbkIsV0FBbUIsRUFDbkIsUUFBZ0I7UUFFaEIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsY0FBYyxDQUN0QyxLQUFLLEVBQ0wsV0FBVyxFQUNYLFdBQVcsRUFDWCxRQUFRLENBQ1QsQ0FBQztJQUNKLENBQUM7SUFFRDs7OztPQUlHO0lBQ0ksbUNBQWMsR0FBckIsVUFBc0IsTUFBYyxFQUFFLEtBQWE7UUFDakQsc0JBQXNCLElBQVk7WUFDaEMsTUFBTSxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztnQkFDYixLQUFLLFVBQVU7b0JBQ2IsTUFBTSxDQUFDLGlCQUFpQixDQUFDO2dCQUUzQjtvQkFDRSxNQUFNLENBQUMsRUFBRSxDQUFDO1lBQ2QsQ0FBQztRQUNILENBQUM7UUFFRCxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxjQUFjLENBQUMsWUFBWSxDQUFDLE1BQU0sQ0FBQyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3hFLENBQUM7SUFDSCxpQkFBQztBQUFELENBQUMsQUE5REQsSUE4REM7QUE5RFksZ0NBQVUifQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/user/index.js
// module id = 207
// module chunks = 44